"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledPaginationItem = exports.StyledPaginationContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledPaginationContainer = styled_components_1.default.div `
  display: flex;
  user-select: none;
  
  &[data-variation='secondary'] {
    justify-content: center;
    max-width: 100%;
  }
`;
exports.StyledPaginationItem = styled_components_1.default.div `
  min-width: 24px;
  text-align: center;

  font-weight: 500;
  font-size: 20px;
  line-height: 24px;

  &:not(:last-child) {
    margin-right: 15px;
  }

  &.item--number {
    cursor: pointer;

    &:hover,
    &.active {
      color: var(--primary-color, #367bf5);
    }
  }

  &[data-variation='secondary'] {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    min-width: initial;
    height: 32px;
    margin: 4px;
    color: #1a1a1a;
    font-size: 14px;
    border-radius: 4px;

    @media screen and (max-width: 767px) {
      background: #f2f2f2;
    }

    &.item--number {
      &:hover {
        color: #1a1a1a;
        background-color: var(--primary-color-hover, #E1EBFD);
      }
      &.active {
        color: #fff;
        background-color: var(--primary-color, #367bf5);
      }
    }

    svg {
      width: 12px;
      height: 12px;
    }
    &.prev {
      transform: rotate(180deg);
    }
    &.disabled {
      color: #c6c6c6;
      pointer-events: none;
    }
  }
`;
//# sourceMappingURL=pagination.styled.js.map